// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"85":"7e00bfe6","206":"5c8bbc06","208":"5c42cc91","450":"ba1205fe","620":"bab1b60a","771":"53963937","935":"d25aec88"}[chunkId] + ".chunk.css";
};